import React from 'react';
var VeltCanvasComment = function (props) {
    var children = props.children, canvasId = props.canvasId, position = props.position;
    return (React.createElement("velt-canvas-comment", { "canvas-id": canvasId, position: JSON.stringify(position) }, children));
};
export default VeltCanvasComment;
